import type { TFunction } from "i18next";

import type { IInfoCardVariantData } from "@components/molecules/infoCard/types";
import { Icon } from "@components/atoms/icons";

export const VInfoCardVariant = (
  t: TFunction<"common">,
): IInfoCardVariantData => ({
  "user-all": {
    icon: <Icon name={"UserCheck"} type={"linear"} color={"white"} />,
    color: "primary",
  },
  "user-pending": {
    icon: <Icon name={"ForbiddenCircle"} type={"linear"} color={"white"} />,
    color: "warning",
  },
  "user-denied": {
    icon: <Icon name={"CloseCircle"} type={"linear"} color={"white"} />,
    color: "danger",
  },
  "user-active": {
    icon: <Icon name={"CheckCircle"} type={"linear"} color={"white"} />,
    color: "success",
  },
  hospital: {
    icon: <Icon name={"ForbiddenCircle"} type={"linear"} color={"white"} />,
    color: "warning",
  },
  clinic: {
    icon: <Icon name={"CloseCircle"} type={"linear"} color={"white"} />,
    color: "danger",
  },
  health_center: {
    icon: <Icon name={"CheckCircle"} type={"linear"} color={"white"} />,
    color: "success",
  },
  "appointment-main": {
    icon: <Icon name={"MonitorCamera"} type={"linear"} color={"white"} />,
    color: "bondi-blue",
    title: t("allVisitTimes"),
  },
  "appointment-warning": {
    icon: <Icon name={"ForbiddenCircle"} type={"linear"} color={"white"} />,
    color: "warning",
    title: t("pendingVisitTimes"),
  },
  "appointment-danger": {
    icon: <Icon name={"CloseCircle"} type={"linear"} color={"white"} />,
    color: "danger",
    title: t("canceledVisitTimes"),
  },
  "appointment-success": {
    icon: <Icon name={"CheckCircle"} type={"linear"} color={"white"} />,
    color: "success",
    title: t("completedVisitTimes"),
  },
  "appointment-pending": {
    icon: <Icon name={"MenuDotsCircle"} type={"linear"} color={"white"} />,
    color: "royal-blue",
    title: t("onGoingVisitTimes"),
  },
  default: {
    icon: <Icon name={"MenuDotsCircle"} type={"linear"} color={"white"} />,
    color: "royal-blue",
  },
  "all-appointments": {
    icon: <Icon name={"MonitorCamera"} type={"linear"} color={"white"} />,
    color: "bondi-blue",
  },
  pending: {
    icon: <Icon name={"ForbiddenCircle"} type={"linear"} color={"white"} />,
    color: "warning",
  },
  completed: {
    icon: <Icon name={"CheckCircle"} type={"linear"} color={"white"} />,
    color: "success",
  },
  accepted: {
    icon: <Icon name={"CheckCircle"} type={"linear"} color={"white"} />,
    color: "success",
  },
  in_session: {
    icon: <Icon name={"MenuDotsCircle"} type={"linear"} color={"white"} />,
    color: "royal-blue",
  },
  canceled: {
    icon: <Icon name={"CloseCircle"} type={"linear"} color={"white"} />,
    color: "danger",
  },
  declined: {
    icon: <Icon name={"CloseCircle"} type={"linear"} color={"white"} />,
    color: "danger",
  },
  pending_summary_note: {
    icon: <Icon name={"MonitorCamera"} type={"linear"} color={"white"} />,
    color: "bondi-blue",
  },
  no_show: {
    icon: <Icon name={"CloseCircle"} type={"linear"} color={"white"} />,
    color: "danger",
  },
  drugstore: {
    icon: <Icon name={"Hospital"} type={"linear"} color={"white"} />,
    color: "warning",
  },
  imaging_center: {
    icon: <Icon name={"Hospital"} type={"linear"} color={"white"} />,
    color: "danger",
  },
  labratory: {
    icon: <Icon name={"Hospital"} type={"linear"} color={"white"} />,
    color: "success",
  },
  attended: {
    icon: <Icon name={"CheckCircle"} type={"linear"} color={"white"} />,
    color: "success",
  },
  unattended: {
    icon: <Icon name={"CloseCircle"} type={"linear"} color={"white"} />,
    color: "danger",
  },
});
